import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import './styles/StudentsPage.css';
import { FaEye, FaEdit } from 'react-icons/fa';

const CostListPage = () => {
    const [costs, setCosts] = useState([]);
    const [searchName, setSearchName] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalData, setTotalData] = useState(0); 
    const navigate = useNavigate();
    const [isSearched, setIsSearched] = useState(false);

    useEffect(() => {
        if (isSearched) {
            handleSearch(); // Fetch students when currentPage changes
        }
    }, [currentPage, isSearched]);

    // Fetch students based on filter when search is clicked
    const handleSearch = async () => {
        try {
            const response = await api.post('/utils/cost/getCostsList', {
                data: [{
                    searchName: searchName
                }],
                limit: 25, // Membatasi data per halaman menjadi 25
                page: currentPage // Mengirim halaman saat ini ke backend
            });
            setCosts(response.data.data.costList);
            setTotalData(response.data.data.totalCount); // Total data tanpa pagination
            setTotalPages(Math.ceil(response.data.data.totalCount / 25)); // Menghitung total halaman berdasarkan total data


            const totalCount = response.data.data.totalCount;
            if (totalCount > 0) {
                setTotalPages(Math.ceil(totalCount / 25));
                if(totalPages < currentPage){
                    setCurrentPage(1);
                }
            } else {
                setCurrentPage(1);
                setTotalPages(1);
            }

            setIsSearched(true);
        } catch (error) {
            console.error("Failed to fetch price list", error);
        }
    };
    

    // Handle pagination
    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(prevPage => prevPage + 1);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(prevPage => prevPage - 1);
        }
    };

    const handleEdit = (costId) => {
        navigate(`/cost/edit/${costId}`);
    };

    const formatCurrency = (amount) => {
        return parseFloat(amount).toLocaleString('id-ID', { minimumFractionDigits: 0 });
    };


    return (
        <div className="students-page">
            <div className="page-title">Kidola Price List</div>
            <div className="form-container">
                <div className="section">
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Item Name</label>
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="Enter item name"
                                            value={searchName}
                                            onChange={(e) => setSearchName(e.target.value)}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        <button onClick={handleSearch}>Search</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="section">
                    <div className="students-list">
                        <table>
                            <thead>
                                <tr>
                                    <th class="no-column">No</th>
                                    <th>Item Name</th>
                                    <th>Item Type</th>
                                    <th>Price</th>
                                    <th>Program</th>
                                    <th>Program Type</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {costs.map((cost, index) => (
                                    <tr key={cost.cost_id}>
                                        <td class="no-column">{index + 1 + (currentPage - 1) * 25}</td>
                                        <td>{cost.cost_item}</td>
                                        <td>{cost.item_type}</td>
                                        <td>{formatCurrency(cost.cost_amount)}</td>
                                        <td>{cost.Program ? cost.Program.program_name : '-'}</td>
                                        <td>{cost.Program ? cost.Program.program_type : '-'}</td>
                                        <td>
                                            <FaEdit className="action-icon" title="Edit Price" onClick={() => handleEdit(cost.cost_id)} />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="total-data">
                        <span>Total Data: {totalData}</span>
                    </div>
                    <div className="pagination">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <button onClick={handlePrevPage} disabled={currentPage === 1}>
                                            Prev
                                        </button>
                                    </td>
                                    <td>
                                        <span>Page {currentPage} of {totalPages}</span>
                                    </td>
                                    <td>
                                        <button onClick={handleNextPage} disabled={currentPage === totalPages}>
                                            Next
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CostListPage;
